const CAROUSEL_ITEMS = [
  {
    title: '2026夏日娱乐圈大震荡：一周内三对明星官宣离婚',
    desc: '从一线演员到顶流歌手，短短一周内接连曝出婚变消息。吃瓜群众直呼"这个夏天太刺激了"。本专题全面梳理事件始末与各方回应。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20editorial%20collage%20style%20image%20with%20crimson%20red%20and%20charcoal%20tones%2C%20abstract%20compositions%20suggesting%20celebrity%20entertainment%20drama%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20glow%2C%20fine%20art%20quality%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-1-91hl&orientation=landscape',
    tag: '热点专题',
  },
  {
    title: '影视圈洗牌进行时：流量明星遭遇寒冬，实力派迎来春天',
    desc: '多部大制作影视项目换角风波背后的行业变迁。流量经济的泡沫是否已经破裂？深度分析当前影视行业用人逻辑的转变。',
    img: 'https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20composition%20in%20deep%20crimson%20and%20charcoal%20tones%20evoking%20film%20industry%2C%20dramatic%20shadows%20and%20warm%20highlights%2C%20cinematic%20atmosphere%2C%20editorial%20quality%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-2-91hl&orientation=landscape',
    tag: '深度专题',
  },
  {
    title: '综艺节目黑幕大起底：选手爆料节目组操控投票全过程',
    desc: '多位参加过选秀节目的选手联合发声，揭露综艺背后的资本博弈与暗箱操作。从投票机制到淘汰安排，内幕令人震惊。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20abstract%20artistic%20image%20with%20crimson%20red%20accents%20on%20charcoal%20background%2C%20dramatic%20texture%2C%20mysterious%20and%20intense%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-3-91hl&orientation=landscape',
    tag: '独家专题',
  },
  {
    title: '网红经济泡沫：头部主播接连翻车，直播带货何去何从',
    desc: '从税务问题到产品质量，网红圈层正在经历前所未有的信任危机。本专题梳理近期翻车主播名单及事件详情，探讨行业未来走向。',
    img: 'https://readdy.ai/api/search-image?query=An%20abstract%20editorial%20composition%20with%20deep%20crimson%20and%20dark%20charcoal%20tones%2C%20dramatic%20lighting%2C%20mysterious%20vibe%2C%20fine%20art%20texture%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-4-91hl&orientation=landscape',
    tag: '行业专题',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-focus-2-line text-primary-400 mr-2"></i>
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">深度聚焦娱乐圈最受关注的黑料事件与行业动态</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-800/40 border border-background-700/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/80 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500/80 backdrop-blur-sm text-background-950 text-xs font-bold">
                  {item.tag}
                </span>
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-100 group-hover:text-primary-300 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}